<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { mapState } from "vuex";
import { ROLE_MODULE } from '@/state/modules/role'
import { roleMethods } from "@/state/helpers";

export default {
  page: {
    title: i18n.t("label.listingX", [i18n.t("module.role")]),
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != "Role-update" && to.name != "Role-create") {
      sessionHelper.clearSearch(SESSION.ROLE_SEARCH);
    }
    next();
  },
  async created() {
    await this.validPermissions();
    this.initSearchCriteria();
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t("module.role")]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.role"),
          active: true,
        },
      ],
      statusDdl: ddlHelper.getActivationStatus(true),
      currentPage: 1,
      filter: "",
      enabled: false,
      permissions: sessionHelper.getPermissions(),
      createPermission: null,
      updatePermission: null,
      updateStatusPermission: null,
      readPermission: null,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      pageOptions: [10, 25, 50, 100],
      filterOn: [],
      sortBy: "name",
      fields: [
        { key: "name", sortable: true, label: i18n.t("label.name") },
        { key: "isActive", sortable: true, label: i18n.t("label.status") },
        { key: "Action", sortable: false, label: i18n.t("label.action") },
      ],
    };
  },
  computed: {
    ...mapState(ROLE_MODULE, ["status"]),
    tableRows() {
      return this.$store.state.role.list.data;
    },
    pagination() {
      return this.$store.state.role.list.pagination;
    },
    totalPage() {
      return this.$store.state.role.list.pagination.total;
    },
  },
  mounted() { },
  methods: {
    ...roleMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      if (jsonPermissions.some(p => p.code === "USER_URC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "USER_URR")) {
        this.readPermission = true;
      }
      else {
        this.readPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "USER_URU")) {
        this.updatePermission = true;
      }
      else {
        this.updatePermission = false;
      }

      if (jsonPermissions.some(p => p.code === "USER_URUS")) {
        this.updateStatusPermission = true;
      }
      else {
        this.updateStatusPermission = false;
      }
    },
    initSearchCriteria() {
      let isDefault = true;

      if (sessionHelper.hasSearchCriteria(SESSION.ROLE_SEARCH)) {
        isDefault = false;
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.ROLE_SEARCH);
        this.currentPage = this.searchCriteria.pageNumber;
      }

      if (isDefault) {
        this.searchCriteria = {
          pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
          pageSize: SHARED.DEFAULT_PAGE_SIZE,
          isActive: this.statusDdl[0].value,
          searchValue: "",
          searchArray: [],
        };
      }
      this.getlist(this.searchCriteria);
    },

    getlist(filter) {
      this.getAllRoles({ filter });
      this.searchCriteria = filter;
      sessionHelper.storeSearch(SESSION.ROLE_SEARCH, filter);
    },

    pageNavigation(pageNumber) {
      let filter = sessionHelper.retrieveSearch(SESSION.ROLE_SEARCH);
      filter.pageNumber = pageNumber;

      this.getlist(filter);
    },

    searchListing() {
      this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

      this.searchCriteria.roleName = "";
      this.searchCriteria.roleName = this.filter;
      if (this.filter == '' || this.filter == null) {
        this.searchCriteria.pageNumber = 1;
        this.currentPage = 1;
      }
      this.getlist(this.searchCriteria);
    },

    toDetailsPage(id) {
      let filter = sessionHelper.retrieveSearch(SESSION.ROLE_SEARCH);
      filter.selectedRecordId = id;
      sessionHelper.storeSearch(SESSION.ROLE_SEARCH, filter);

      this.$router.push({
        name: "Role-update",
      });
    },

    editStatus(role) {
      const data = {
        id: role.uuid,
        isActive: role.isActive,
      };

      this.updateRoleStatus({ filter: this.searchCriteria, data });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: left">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("label.search") }}
                    <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                      class="form-control form-control-sm ml-2" @change="searchListing"></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: right">
                  <router-link tag="a" to="/role/create" style="float: right; margin-bottom: 10px"
                    v-if="createPermission == true" class="btn btn-primary w-md waves-effect waves-light">
                    {{ $t("label.createX", [$t("module.role")]) }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                v-if="readPermission == true">
                <template #cell(action)="data">
                  <a href="javascript:void(0);"
                    @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                    v-if="readPermission == true && updatePermission == true" title="Edit">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>

                  <a href="javascript:void(0);" @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                    style="margin-left: 5px;" v-if="readPermission == true && updatePermission != true" title="Read">
                    <i class="mdi mdi-file-search-outline font-size-18"></i>
                  </a>
                </template>
                <template #cell(isActive)="data">
                  <b-form-checkbox @change="editStatus(tableRows[data.index])" v-model="tableRows[data.index].isActive"
                    :disabled="updateStatusPermission == false" switch class="mb-1">
                  </b-form-checkbox>
                </template>
              </b-table>
              <div style="text-align: center;" v-else>
                {{ $t('message.noPermissionMessage') }}
              </div>
            </div>
            <div class="row" v-if="this.readPermission == true">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="pagination.total" :per-page="perPage"
                      @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>